export default "__VITE_ASSET__Cs19f3Hx__"